export default "__VITE_ASSET__BB44OAKP__"